import React, { useContext, Suspense } from "react";
import { Route, Redirect, RouteProps } from "react-router-dom";
import { Url } from "routes";
import { AuthContext } from "contexts/AuthContext";
import { PageLoading } from "template/PageLoading";
import MasterPage, { MasterPageLayoutProps } from "template/MasterPage";
import { usePageRights } from "routes/roles";
import UnauthorizedPage from "./error-pages/UnauthorizedPage";

type Props = {
  component: React.FC<any>;
} & RouteProps &
  MasterPageLayoutProps;

function PrivateRoute({
  component: Component,
  header,
  footer,
  drawer,
  ...rest
}: Props) {
  const { isAuthenticated } = useContext(AuthContext);

  const hasRight = usePageRights();

  if (!Component)
    throw new Error(`A component needs to be specified for path ${rest.path}`);

  return (
    <Route
      {...rest}
      render={renderProps =>
        isAuthenticated() ? 
        hasRight ? (
          <MasterPage footer={footer} header={header} drawer={drawer}>
            <Suspense fallback={<PageLoading />}>
              <Component {...renderProps} />
            </Suspense>
          </MasterPage>
        ) : (
          <UnauthorizedPage />
        ) : (
          <Redirect
            to={{
              pathname: Url.login,
              state: { from: renderProps.location }
            }}
          />
        )
      }
    />
  );
}

export default PrivateRoute;
